/**
 * Shows at most 5 slideshow pagination dots at a time (product page mobile
 * gallery). The window follows the selected dot; when more images follow the
 * window, its last dot is shown half size. Styles: pacc-armor.css.
 *
 * Wraps the theme's `.slideshow-controls__dots` list (see slideshow-controls
 * snippet, `windowed_dots`). The slideshow marks the selected dot with
 * `aria-selected`; this only reacts to that and toggles classes on the <li>s.
 */
const MAX_DOTS = 5;

class PaccDotsWindow extends HTMLElement {
  /** @type {MutationObserver | undefined} */
  #observer;

  connectedCallback() {
    this.#observer = new MutationObserver(() => this.#update());
    this.#observer.observe(this, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-selected'] });
    this.#update();
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #update() {
    const items = [...this.querySelectorAll('li')];
    const count = items.length;

    let start = 0;
    let end = count - 1;

    if (count > MAX_DOTS) {
      const selected = Math.max(
        0,
        items.findIndex((item) => item.querySelector('[aria-selected="true"]'))
      );
      // Keep the selected dot off the last (small) position while more images follow
      start = Math.min(Math.max(selected - (MAX_DOTS - 2), 0), count - MAX_DOTS);
      end = start + MAX_DOTS - 1;
    }

    items.forEach((item, index) => {
      item.classList.toggle('pacc-dot--hidden', index < start || index > end);
      item.classList.toggle('pacc-dot--small', index === end && end < count - 1);
    });
  }
}

if (!customElements.get('pacc-dots-window')) {
  customElements.define('pacc-dots-window', PaccDotsWindow);
}
